goog.provide("shadow.js.shim.module$$mui$material$TableRow");
goog.provide("module$shadow_js_shim_module$$mui$material$TableRow");
shadow.js.shim.module$$mui$material$TableRow = shadow.js.nativeProvides["@mui/material/TableRow"] = shadow$bridge("@mui/material/TableRow");
module$shadow_js_shim_module$$mui$material$TableRow.default = shadow.js.shim.module$$mui$material$TableRow;
